export default __webpack_public_path__ + "static/media/Mace of the Champion.9e8c9f8b.jpg";